import React, { FunctionComponent } from 'react';
import i18next from 'i18next';

import LayoutContainer from 'containers/LayoutContainer';
import ProceduresButtons from 'views/public/ProceduresView/components/ProceduresButtons';
import useTypedSelector from 'hooks/useTypedSelector';
import { userSelector } from 'redux/selectors/auth.selector';

import { Title, ViewContainer, ViewContent } from 'styles/view';

import 'views/public/ProceduresView/i18n';

const ProceduresContainer: FunctionComponent = () => {
  const user = useTypedSelector(userSelector);
  const isClient = user?.roles?.some((role) => role.name === 'cliente');
  const isVerified = !isClient || !!user?.emailVerifiedAt;
  return (
    <LayoutContainer isPublic title={i18next.t<string>('PUBLIC_PROCEDURES_VIEW:TITLE')}>
      <ViewContainer auth data-testid="public-procedures-view">
        <ViewContent auth>
          <Title>{i18next.t<string>('PUBLIC_PROCEDURES_VIEW:SUBTITLE')}</Title>
          <ProceduresButtons isVerified={isVerified} />
        </ViewContent>
      </ViewContainer>
    </LayoutContainer>
  );
};

export default ProceduresContainer;
